import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { getGoodsReceiptStatusLabel } from "../../utils"

import { GoodsReceiptStatus } from "@/graphql/codegen/graphql"

interface GoodsReceiptStatusChipProps {
  status: GoodsReceiptStatus
  className?: string
  "data-testid"?: string
}

export const GoodsReceiptStatusChip: FC<GoodsReceiptStatusChipProps> = ({
  status,
  className,
  "data-testid": testId,
}) => {
  const isWarning = [GoodsReceiptStatus.Incoming, GoodsReceiptStatus.SoftReceived].includes(status)

  return (
    <Chip
      variant='outlined'
      color={isWarning ? "warning" : "success"}
      className={twMerge("h-6 text-xs", className)}
      label={getGoodsReceiptStatusLabel(status)}
      data-testid={testId}
    />
  )
}
